/**
 * @deprecated use ServerZoneType instead
 */
export var ServerZone;
(function (ServerZone) {
    ServerZone["US"] = "US";
    ServerZone["EU"] = "EU";
})(ServerZone || (ServerZone = {}));
//# sourceMappingURL=server-zone.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amplitude/analytics-types/lib/esm/server-zone.js
// module id = 715
// module chunks = 1